"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingBagIcon = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _icons = require("@ori-ui/icons");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _useTranslations = require("../../hooks/useTranslations");
var _components = require("./components");
var _constants2 = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ShoppingBagIcon = () => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isECatalogue,
    isMobile
  } = (0, _hooks.useDeviceType)();
  const isMobileOnECatalogue = isECatalogue && isMobile;
  const isCnMarket = tenant === _constants.CN_MARKET;
  const Icon = isCnMarket ? _icons.EmptyBasket : _icons.AddToBag;
  const IconOnHover = isCnMarket ? _icons.ShoppingBasketFilled : _icons.AddToBagFilled;
  const {
    onBasketUpdated,
    onShoppingContextLoaded,
    isReceivedShoppingContext,
    shoppingBagQuantity
  } = (0, _hooks.useShoppingBag)();
  (0, _react.useEffect)(() => {
    window.addEventListener(ShoppingContextLoaded.Name, onShoppingContextLoaded);
    window.addEventListener(BasketUpdated.Name, onBasketUpdated);
    (0, _utils.triggerRequestShoppingContext)();
    return () => {
      window.removeEventListener(ShoppingContextLoaded.Name, onShoppingContextLoaded);
      window.removeEventListener(BasketUpdated.Name, onBasketUpdated);
    };
  }, [onShoppingContextLoaded, onBasketUpdated]);
  (0, _react.useEffect)(() => {
    if (isReceivedShoppingContext) {
      window.removeEventListener(ShoppingContextLoaded.Name, onShoppingContextLoaded);
    }
  }, [isReceivedShoppingContext, onShoppingContextLoaded]);
  const onMouseEnter = (0, _react.useCallback)(() => {
    if (isECatalogue || isMobile) {
      return;
    }
    window.dispatchEvent((0, _utils.getMinibagFlyoutEvent)(true));
  }, [isECatalogue, isMobile]);
  const onMouseLeave = (0, _react.useCallback)(() => {
    if (isECatalogue || isMobile) {
      return;
    }
    window.dispatchEvent((0, _utils.getMinibagFlyoutEvent)(false));
  }, [isECatalogue, isMobile]);
  const onMobileEcataloguePageClick = (0, _react.useCallback)(() => {
    window.dispatchEvent((0, _utils.getMinibagFlyoutEvent)());
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ShoppingBagCounter, {
    shoppingBagQuantity: shoppingBagQuantity,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      disableRipple: isMobileOnECatalogue,
      "aria-label": translations.shoppingBag,
      isCnMarket: isCnMarket,
      href: isMobileOnECatalogue ? undefined : '/shopping/basket',
      "data-testid": getTestId(_constants2.SHOPPING_BAG_ICON_ROOT),
      hoverIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconOnHover, {
        fontSize: "inherit"
      }),
      variant: "text",
      onClick: isMobileOnECatalogue ? onMobileEcataloguePageClick : undefined,
      onMouseEnter: isMobileOnECatalogue ? undefined : onMouseEnter,
      onMouseLeave: isMobileOnECatalogue ? undefined : onMouseLeave,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        fontSize: "inherit"
      })
    })
  });
};
exports.ShoppingBagIcon = ShoppingBagIcon;
